<div class="message-wrapper">
  <div class="message-box">
    <h2>Down for maintenance</h2>
    <p>
      System is temporarily unavailable due to planned ....
    </p>
  </div>
</div>
